import React, {useEffect, useState } from 'react'
import { Container,Button,Row, Col } from 'reactstrap'
import {useHistory} from 'react-router-dom'
import DualListBox from 'react-dual-listbox'
import Header from '../header/Header'
import Footer from '../footer/Footer';
import { useToasts } from '../toastManager/ToastManager'
import 'react-dual-listbox/lib/react-dual-listbox.css';
import 'font-awesome/css/font-awesome.min.css'
import backend from '../../services/backend'
import './conversationAttributes.css'
import AlertModal from '../Modals/alertModal/AlertModal'
import WaitingModal from '../Modals/waitingModal/WaitingModal'
import ConfirmationModal from '../Modals/confirmationModal/ConfirmationModal'


const ConversationAttributes = (props) => {
     const history = useHistory()
     const { add } = useToasts()
    const [availableColumns, setAvailableColumns] = useState([]);
    const [visibleColumns, setVisibleColumns] = useState();
    const [isWaitingModalOpen, setIsWaitingModalOpen] = useState(false)
    const [waitingHeader, setWaitingHeader] = useState(false)
    const [error, setError] = useState()
    const [message, setMessage] = useState()

    const getAvailableAttributes = async() => {
        try {
        setIsWaitingModalOpen(true)
        setWaitingHeader("Retrieving the column attributes")
        const availableReponse = await backend.getConversationsSettings(sessionStorage.getItem('r2s-token'))
        const allColumns = availableReponse.conversationSettings.conversationColumns
        setAvailableColumns(allColumns)
        setVisibleColumns(allColumns.map( x => x.visible ? x.value : '').filter( x => x != ""))
        sessionStorage.setItem('r2s-availableAttributes', JSON.stringify(allColumns))
        } catch (error) {
            setError(`An error occured while fetching data:${JSON.stringify(error.message)}`)
            console.log(error)
        } finally {
            setIsWaitingModalOpen(false)
        }
    }

    const putVisibleAttributes = async(orderedColumns) => {
        try {
            setIsWaitingModalOpen(true)
            setWaitingHeader("Updating the column attributes")
            const visibleResponse = await backend.updateConversationsSettings(sessionStorage.getItem('r2s-token'),orderedColumns)
            setIsWaitingModalOpen(false)
            setMessage(`Attributes has been updated successfully`)
            const timeout = setTimeout(() => {
                history.push("/conversations");
              }, 2000);
        } catch (error) {
            setError(`An error occured while fetching data:${JSON.stringify(error.message)}`)
            console.log(error)
        } finally {
            setIsWaitingModalOpen(false)
        }
    }


    const getOrderedArray = () => {
        const orderedColumn = []
        const temporaryColumn = availableColumns
        const visibleCol = visibleColumns
        for (let i=0 ; i < visibleCol.length ; i++)
            {
                const moveIndex = temporaryColumn.findIndex(obj => obj.value == visibleCol[i])
                orderedColumn.push(temporaryColumn[moveIndex])
                temporaryColumn.splice(moveIndex, 1)
            };
        return orderedColumn.concat(temporaryColumn)
    }

    useEffect(() => {
        getAvailableAttributes()
    },[])


    return (
        <div id="component-wrap">
            <Header role={props.role}/>
            <div id="main">
                    <WaitingModal
                    isOpen={isWaitingModalOpen}
                    header = {waitingHeader}
                     />

                    <ConfirmationModal
                    isOpen={!!message}
                    header='Success!'
                    toggle={() => { setMessage(undefined) }}
                    body={message}
                    />  

                    <AlertModal
                    isOpen={!!error}
                    header='Error'
                    toggle={() => { setError(undefined) }}
                    body={error}
                    />
                <br />
                <lablel className = "title-name">Search View</lablel>
                <hr className = "hori-line"/>
                
             <Row className = "label-name">
                <Col>
                <label >
                    Available
                </label>
                </Col>

                <Col>
                <label > 
                    Visible
                </label> 
                </Col>
             </Row>           

                <DualListBox className="list-box"
                    icons={{
                            moveLeft: <span className="fa fa-angle-left" />,
                            moveAllLeft: <span className="fa fa-angle-double-left" />,
                            moveRight: <span className="fa fa-angle-right" />,
                            moveAllRight: <span className="fa fa-angle-double-right" />,
                            moveDown: <span className="fa fa-angle-down" />,
                            moveUp: <span className="fa fa-angle-up" />,
                            moveTop: <span className ="fa fa-angle-double-up" />,
                            moveBottom: <span className ="fa fa-angle-double-down" />,
                        }}
                    preserveSelectOrder
                    showOrderButtons
                    options={availableColumns}
                    selected={visibleColumns}
                    onChange={e => setVisibleColumns(e)}
                />
           <br />
           <Row className = "buttons">
               
                <Button color="primary" onClick={() => {
                    availableColumns.forEach((item) => visibleColumns.indexOf(item.value) > -1 ? item.visible = true : item.visible = false)
                    const orderedColumns = getOrderedArray(availableColumns,visibleColumns)
                    putVisibleAttributes(orderedColumns)
                   // console.log(availableColumns,visibleColumns)
                }}> Save </Button>
                &nbsp;&nbsp;
                            <Button color="secondary" onClick={() => {
                   // console.log("cancelling...")
                    history.push("/conversations")
                }}> Cancel </Button>

                
      </Row>

      </div>
            <Footer version="0.1" />
        </div>
    )
}


export default ConversationAttributes